module.exports = {
      id: "glyph:copy-file-usage",
      viewBox: "0 0 64 64",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:copy-file-usage",
      toString: function () {
        return this.url;
      }
    }